import { IIconBase } from '..'

const importBlackIcon = ({
  color = '#131523',
  height = 40,
  width = 41,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 41 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/import'>
        <g id='import'>
          <path
            id='Vector'
            d='M16.0333 19.4668L20.3 23.7335L24.5667 19.4668'
            stroke={color}
            strokeWidth='1.5'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M20.3 6.6665V23.6165'
            stroke={color}
            strokeWidth='1.5'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_3'
            d='M33.8333 20.2998C33.8333 27.6665 28.8333 33.6331 20.5 33.6331C12.1667 33.6331 7.16666 27.6665 7.16666 20.2998'
            stroke={color}
            strokeWidth='1.5'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export default importBlackIcon
